import { A4uVolumeMute as IconComponent } from '@adobe/react-spectrum-workflow/dist/VolumeMute.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function VolumeMute(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}